import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Pollsandsurvey } from 'src/app/model/pollsandsurvey.model';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';
import { DateService } from 'src/app/services/date.service';
import { DatePipe } from '@angular/common';
import { RemovemodalcouponsurveyComponent } from 'src/app/modal/remove-modal-coupon-survey/remove-modal-coupon-survey.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
@Component({
  standalone: false,
  selector: 'app-list-polls-survey',
  templateUrl: './list-polls-survey.component.html',
  styleUrls: ['./list-polls-survey.component.scss']
})
export class ListPollsSurveyComponent implements OnInit {

  public pollsandsurvey = new Pollsandsurvey();
  private subscriptions = new Subscription();

  prakList: any = [];
  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;
  totalCount;
  displayCount;
  mainSurveyList: any[] = [];
  newmainSurveyList: any[] = [];
  surveyDeepCopy: any;
  newMainSurveys: any;
  surveyTempNew: any;
  masterSelectedSurvey: boolean;
  checkedSurveyList: any;
  checkedOnlySurveyList: any;
  formatToDate: any;
  surveyStartDate: any;
  surveyEndDate: any;
  formatDate: any;
  selectedDate: any;
  selectedToDate: any;
  tempDate: any;
  selectedSurveyName: any;
  mainSurveyTypes = [];
  searchGroup: string = '';
  multiSelectGroup: any;
  searchSurveyList = [];
  formattedSelectedDate: string = '';
  formattedSelectedToDate: string = '';
  fromDate: any;
  fDate: any;
  toDate: any;
  tDate: string;
  isDesc: boolean = false;
  column: string = 'surveyStartDate';
  searchSurveyListDate = [];
  mainSurveyLatestTypes = [];
  selectedSurveySortName: any;
  searchGroupSort: string = '';
  multiSelectGroupSort: any;
  onlySurveyIds = [];
  fromListPage = 'yes';
  toDateModified: any;
  newMonth: any;
  newDay: any;
  newMonthFrom: any;
  newDayFrom: any;
  fromDateModified: any;
  surveyIdsFinal = [];
  singleSurveyDataDelete = [];
  surveyRemove: any;

  constructor(
    private pollsandsurveyService: PollsandsurveyService,
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private ngbCalendar: NgbCalendar,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavCreateview', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Create and View',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {

    this.surveyRemove = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:Remove');

    localStorage.removeItem('previous_survey_id_draft');
    localStorage.removeItem('current_survey_id_draft');

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.getTheLatestOldestFilter();
    this.getTheSurveyist();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.pollsandsurveyService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverSort(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      if (this.multiSelectGroup == 'All' || this.multiSelectGroupSort == 'All') {
        this.newmainSurveyList = this.mainSurveyList;
      } else {
        if (this.searchSurveyList.length > 0) {
          this.newmainSurveyList = this.searchSurveyList;
        } else if (this.searchSurveyListDate.length > 0) {
          this.newmainSurveyList = this.searchSurveyListDate;
        } else {
          this.newmainSurveyList = this.mainSurveyList;
        }
      }
      this.totalRows = this.newmainSurveyList?.length;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    let sourceList: any[] = [];

    if (this.searchSurveyList.length > 0) {
      sourceList = this.searchSurveyList;
    } else if (this.searchSurveyListDate.length > 0) {
      sourceList = this.searchSurveyListDate;
    } else {
      sourceList = this.mainSurveyList;
    }

    this.newmainSurveyList = sourceList.filter((item: { surveyName: any }) => {
      if (!item || !item.surveyName) return false;
      return item.surveyName.toLowerCase().includes(searchLower);
    });
    this.totalRows = this.newmainSurveyList?.length;
  }

  getFilteredSurveyLatestTypes(): any[] {
    if (!this.mainSurveyLatestTypes || !Array.isArray(this.mainSurveyLatestTypes)) {
      return [];
    }
    if (!this.searchGroupSort || this.searchGroupSort === '') {
      return this.mainSurveyLatestTypes;
    }
    const searchLower = this.searchGroupSort.toLowerCase();
    return this.mainSurveyLatestTypes.filter((item: any) => {
      if (!item || !item.surveyTypeNameSort) return false;
      return item.surveyTypeNameSort.toLowerCase().includes(searchLower);
    });
  }

  handelSurveyList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  goToSurveyDetails(id, surveyname) {
    localStorage.setItem('survey_name', surveyname);
    this.pollsandsurveyService.setOptionDynamic('survey_name', surveyname);
    //this.router.navigate(['/survey-details/' + id]);
    this.router.navigate(['/survey-report/' + id]);
  }

  checkUncheckAll() {
    for (var i = 0; i < this.mainSurveyList.length; i++) {
      this.mainSurveyList[i].isSelected = this.masterSelectedSurvey;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedSurvey);
    if (this.masterSelectedSurvey === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedSurvey = this.mainSurveyList.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedSurvey);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedSurveyList = [];
    this.checkedOnlySurveyList = [];
    this.onlySurveyIds = [];

    for (var i = 0; i < this.mainSurveyList?.length; i++) {

      if (this.mainSurveyList[i].isSelected) {

        this.checkedSurveyList.push(this.mainSurveyList[i]);
        this.checkedOnlySurveyList.push(this.mainSurveyList[i]);

        this.showDropdown = true;
      }
    }

    for (var j = 0; j < this.checkedOnlySurveyList?.length; j++) {
      this.onlySurveyIds.push(this.checkedOnlySurveyList[j].surveyId);
    }

    console.log(this.onlySurveyIds);
    this.checkedSurveyList = JSON.stringify(this.checkedSurveyList);

  }


  getTheSurveyist() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.pollsandsurveyService.getAllPollsAndSurveyList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainSurveyList = res?.list;
        // this.newmainSurveyList = res?.list;
        this.newmainSurveyList = res?.list.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
        this.newMainSurveys = res;
        this.surveyDeepCopy = JSON.parse(JSON.stringify(res));
        this.surveyTempNew = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainSurveyList = [];
        this.newmainSurveyList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainSurveyList?.length; i++) {
      this.mainSurveyList[i].isSelected = false;
    }

    console.log(this.mainSurveyList);

    // this.getCheckedItemList();
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type

    }
  }

  getTheLatestOldestFilter() {

    this.mainSurveyLatestTypes.push({
      surveyTypeIdSort: null,
      surveyTypeNameSort: "Oldest"
    },
      {
        surveyTypeIdSort: null,
        surveyTypeNameSort: "Latest"
      }
    );
    const allOpt = {
      surveyTypeIdSort: null,
      surveyTypeNameSort: "All"
    }
    this.mainSurveyLatestTypes.unshift(allOpt);
    this.selectedSurveySortName = this.mainSurveyLatestTypes[0].surveyTypeNameSort;
  }

  selectSurveyTypeSort(item) {

    console.log(item);

    this.selectedSurveySortName = item.surveyTypeNameSort;

    if (item.surveyTypeNameSort !== null) {
      if (this.multiSelectGroupSort == item.surveyTypeNameSort) {
        this.multiSelectGroupSort.splice(this.multiSelectGroupSort.indexOf(item.surveyTypeNameSort), 1);
      } else {
        this.newMainSurveys.list = this.surveyDeepCopy.list;
        this.multiSelectGroupSort = item.surveyTypeNameSort;
      }
    }
    else {
      this.multiSelectGroupSort = 'All';
    }

    // if (this.multiSelectGroupSort != '') {
    //   this.selectedSurveySortName = this.mainSurveyList.filter(group => group.surveyStartDate === this.multiSelectGroupSort)[0].surveyStartDate;
    // } else {
    //   this.selectedSurveySortName = this.mainSurveyList[0].surveyStartDate;
    // }

  }

  public async updateSelectedDate(date: NgbDate) {

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.fromDate = jsDate;

    this.newMonthFrom = date.month;
    if (date.month < 10) {
      this.newMonthFrom = '0' + date.month;
    }
    this.newDayFrom = date.day;
    if (date.day < 10) {
      this.newDayFrom = '0' + date.day;
    }
    this.fromDateModified = date.year + '-' + this.newMonthFrom + '-' + this.newDayFrom;

    this.toDateModified = this.toDateModified ? this.toDateModified : this.datepipe.transform(this.toDate, 'YYYY-MM-dd');

    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );

    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {

        //working
        // this.newmainSurveyList = this.mainSurveyList.filter((item) => {
        //   return this.datepipe.transform(item.surveyStartDate, 'MM/dd/yyyy') >= this.datepipe.transform(this.fromDate, 'MM/dd/yyyy') && this.datepipe.transform(item.surveyStartDate, 'MM/dd/yyyy') <= this.datepipe.transform(this.toDate, 'MM/dd/yyyy');
        // });

        this.newmainSurveyList = this.mainSurveyList.filter((item) => {
          return this.datepipe.transform(item.surveyStartDate, 'YYYY-MM-dd') >= this.fromDateModified && this.datepipe.transform(item.surveyStartDate, 'YYYY-MM-dd') <= this.toDateModified;
        });

        console.log(this.newmainSurveyList);

        this.searchSurveyListDate = this.newmainSurveyList;

        this.totalRows = this.newmainSurveyList.length;
        this.totalCount = this.newmainSurveyList.length;
        this.displayCount = Math.ceil(this.totalCount / this.pageSize);

      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        // this.resetDate(localStorage.getItem("temp"));

        // this.appStateSrv.showToast(
        //   'From date should not be greater than to date'
        // );
        // await delay(2000);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {
    
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;

    this.newMonth = date.month;
    if (date.month < 10) {
      this.newMonth = '0' + date.month;
    }
    this.newDay = date.day;
    if (date.day < 10) {
      this.newDay = '0' + date.day;
    }
    this.toDateModified = date.year + '-' + this.newMonth + '-' + this.newDay;

    this.selectedToDate = this.datepipe.transform(jsDate, 'YYYY-MM-dd');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.newmainSurveyList = this.mainSurveyList.filter((item) => {
          return this.datepipe.transform(item.surveyStartDate, 'YYYY-MM-dd') >= this.datepipe.transform(this.fromDate, 'YYYY-MM-dd') && this.datepipe.transform(item.surveyStartDate, 'YYYY-MM-dd') <= this.toDateModified;
        });
        this.searchSurveyListDate = this.newmainSurveyList;
        this.totalRows = this.newmainSurveyList.length;
        this.totalCount = this.newmainSurveyList.length;
        this.displayCount = Math.ceil(this.totalCount / this.pageSize);
      } else {
        this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy')
        // this.tDate = this.fDate
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        // this.resetDate(localStorage.getItem("temp"));

        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  sort(property: string, list: any[]) {
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    let direction = this.isDesc ? -1 : 1;

    let sortedArray = list.sort(function (a, b) {
      if (a[property] > b[property]) {
        return -1 * direction;
      } else if (a[property] < b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return sortedArray;
  }

  openModalRemoveSurvey(surveyId: any): void {

    this.singleSurveyDataDelete.push({
      "surveyId": surveyId,
      "deletedBy": localStorage.getItem('claAdminId')
    });

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalcouponsurveyComponent, modalOptions);
    modalRef.componentInstance.surveyId = this.singleSurveyDataDelete[0];
    modalRef.componentInstance.fromDetailsPage = 'no';
  }

}
